import { DashboardLayout } from 'app/layout'
import { Button } from 'shared/components/Button'
import { useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BackButton } from 'shared/components/BackButton'
import { useDispatch } from 'react-redux'
import { closeModal, openModal } from 'shared/redux/slice/modalSlice'
import { axiosApi } from 'shared/api/axios'
import { showNotification } from 'shared/redux/slice/notificationSlice'
import { CLIENTSLIST } from 'shared/consts/routingConsts'
import { ClientsProfile } from 'features/Clients'
import { FormikHelpers } from 'formik'
import { useQueryClient } from '@tanstack/react-query'

export const Profile = () => {
    const queryClient = useQueryClient()

    const edition = 'Редактировать'

    const formikRef = useRef<FormikHelpers<any>>(null)
    const { id } = useParams()

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [isEditable, setIsEditable] = useState(false)
    const [editButtonText, setEditButtonText] = useState(edition)
    const [isBlackList, setIsBlackList] = useState<boolean | undefined | null>(
        null,
    )

    const [disabled, setDisabled] = useState(false)

    const toggleEdit = () => {
        setIsEditable(!isEditable)
        setEditButtonText(isEditable ? 'Редактировать' : 'Сохранить')
        if (isEditable && formikRef.current) {
            formikRef.current.submitForm().then()
        }
    }

    const cancelEdit = () => {
        setIsEditable(false)
        setEditButtonText(edition)
        formikRef.current?.resetForm()
        dispatch(closeModal())
    }

    const handleRemoveBlacList = async (id: any) => {
        dispatch(closeModal())
        try {
            const response = await axiosApi.delete(
                `${process.env.API_BACKEND}/v1/counterparties/counterparty/black_list/`,
                {
                    data: {
                        counterparty_ids: [id],
                        comment: '',
                    },
                },
            )
            if (response.status === 204) {
                dispatch(
                    showNotification({ message: 'Успешно!', type: 'success' }),
                )
                await queryClient.invalidateQueries({
                    queryKey: ['getProfileSingle'],
                    refetchType: 'active',
                })
            }
        } catch (error) {
            console.log(error)
            throw error
        }
    }

    const handleDeleteClients = async (id: any) => {
        dispatch(closeModal())
        try {
            const response = await axiosApi.delete(
                `${process.env.API_BACKEND}/v1/counterparties/counterparty/`,
                {
                    data: {
                        counterparty_ids: [id],
                    },
                },
            )
            if (response.status === 204) {
                dispatch(
                    showNotification({ message: 'Успешно!', type: 'success' }),
                )
                navigate(CLIENTSLIST)
            }
        } catch (error) {
            console.log(error)
            throw error
        }
    }

    const handleAddBlackList = async (id: any, comment?: string) => {
        dispatch(closeModal())
        try {
            const response = await axiosApi.post(
                `${process.env.API_BACKEND}/v1/counterparties/counterparty/black_list/`,
                {
                    counterparty_ids: [id],
                    comment: comment,
                },
            )
            if (response.status === 204) {
                dispatch(
                    showNotification({ message: 'Успешно!', type: 'success' }),
                )
                await queryClient.invalidateQueries({
                    queryKey: ['getProfileSingle'],
                    refetchType: 'active',
                })
            }
        } catch (error) {
            console.log(error)
            throw error
        }
    }

    return (
        <DashboardLayout
            header={
                <div className='dashboard__header'>
                    <BackButton
                        text='Назад'
                        onClick={() => navigate(-1)}
                    />
                    <div className='dashboard__right-menu'>
                        {isEditable ? (
                            <>
                                <Button
                                    requiredPermission='edit'
                                    themeType={
                                        isEditable ? 'primary' : 'outline-2'
                                    }
                                    bgLoading='white'
                                    onClick={toggleEdit}
                                    disabled={disabled}
                                >
                                    {editButtonText}
                                </Button>
                                <Button
                                    requiredPermission='add'
                                    themeType='outline-2'
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                isOpen: true,
                                                content: (
                                                    <>
                                                        Вы точно хотите отменить
                                                        редактирование?
                                                    </>
                                                ),
                                                config: {
                                                    title: 'Вы точно хотите отменить?',
                                                    btns: [
                                                        {
                                                            onClick: () =>
                                                                cancelEdit(),
                                                            title: 'Да',
                                                            active: true,
                                                        },
                                                        {
                                                            onClick: () =>
                                                                dispatch(
                                                                    closeModal(),
                                                                ),
                                                            title: 'Нет',
                                                            active: false,
                                                        },
                                                    ],
                                                },
                                            }),
                                        )
                                    }
                                >
                                    Отменить
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    requiredPermission='edit'
                                    themeType={'outline-2'}
                                    onClick={toggleEdit}
                                >
                                    {editButtonText}
                                </Button>
                                {isBlackList ? (
                                    <Button
                                        requiredPermission='delete'
                                        themeType='outline-2'
                                        onClick={() =>
                                            dispatch(
                                                openModal({
                                                    isOpen: true,
                                                    content: (
                                                        <div className='blockWithComment'>
                                                            Вы уверены, что
                                                            хотите удалить
                                                            пользователя
                                                            <br />
                                                            из черного списка?
                                                        </div>
                                                    ),
                                                    config: {
                                                        title: 'Вы точно хотите удалить?',
                                                        btns: [
                                                            {
                                                                onClick: () =>
                                                                    handleRemoveBlacList(
                                                                        id,
                                                                    ),
                                                                title: 'Да',
                                                                active: true,
                                                            },
                                                            {
                                                                onClick: () =>
                                                                    dispatch(
                                                                        closeModal(),
                                                                    ),
                                                                title: 'Нет',
                                                                active: false,
                                                            },
                                                        ],
                                                    },
                                                }),
                                            )
                                        }
                                    >
                                        Удалить из черного списка
                                    </Button>
                                ) : (
                                    <Button
                                        requiredPermission='add'
                                        themeType='outline-2'
                                        onClick={() => {
                                            let localComment = ''
                                            dispatch(
                                                openModal({
                                                    isOpen: true,
                                                    content: (
                                                        <div className='blockWithComment'>
                                                            Вы уверены, что
                                                            хотите добавить
                                                            пользователя
                                                            <br />
                                                            в черный список?
                                                            <textarea
                                                                placeholder='Комментарий'
                                                                onChange={e =>
                                                                    (localComment =
                                                                        e.target
                                                                            .value)
                                                                }
                                                            />
                                                        </div>
                                                    ),
                                                    config: {
                                                        title: 'Вы точно хотите удалить?',
                                                        btns: [
                                                            {
                                                                onClick: () =>
                                                                    handleAddBlackList(
                                                                        id,
                                                                        localComment,
                                                                    ),
                                                                title: 'Да',
                                                                active: true,
                                                            },
                                                            {
                                                                onClick: () =>
                                                                    dispatch(
                                                                        closeModal(),
                                                                    ),
                                                                title: 'Нет',
                                                                active: false,
                                                            },
                                                        ],
                                                    },
                                                }),
                                            )
                                        }}
                                    >
                                        Добавить в черный список
                                    </Button>
                                )}
                                <Button
                                    requiredPermission='delete'
                                    themeType='delete'
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                isOpen: true,
                                                content: (
                                                    <>
                                                        Вы точно хотите удалить
                                                        профиль пользователя?
                                                    </>
                                                ),
                                                config: {
                                                    title: 'Вы точно хотите удалить?',
                                                    btns: [
                                                        {
                                                            onClick: () =>
                                                                handleDeleteClients(
                                                                    id,
                                                                ),
                                                            title: 'Да',
                                                            active: true,
                                                        },
                                                        {
                                                            onClick: () =>
                                                                dispatch(
                                                                    closeModal(),
                                                                ),
                                                            title: 'Нет',
                                                            active: false,
                                                        },
                                                    ],
                                                },
                                            }),
                                        )
                                    }
                                >
                                    Удалить клиента
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            }
        >
            <ClientsProfile
                isEditable={isEditable}
                setIsEditable={setIsEditable}
                formikRef={formikRef}
                setEditButtonText={setEditButtonText}
                setDisabled={setDisabled}
                setIsBlackList={setIsBlackList}
            />
        </DashboardLayout>
    )
}
